import { jwtDecode } from 'jwt-decode';

export const tokenDecoder = (token: string) => {
  const base64 = window.atob(token);

  const jwt = jwtDecode(base64);

  return jwt;
};